export default __webpack_public_path__ + "static/media/line.041ef6a6.svg";